import * as z from 'zod';

import { inventoryQueryLinkerSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import { inventoryKitQuerySchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory-kit';

export const inventoryAndKitQuerySchema = z.union([inventoryQueryLinkerSchema, inventoryKitQuerySchema]);
export const inventoryAndKitTypeSchema = z.union([z.literal('inventory'), z.literal('kit')]);
export type InventoryAndKitTypeSchema = z.infer<typeof inventoryAndKitTypeSchema>;
